import React from "react";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <div className="flex items-center  mt-16 h-[30rem] md:h-full mb-6 md:py-5 md:mb-20 md:flex-wrap md:px-3 ">
      <div className="hidden sm:block">
        <img src="/hero.png " />
      </div>
      <div className="w-1/2 md:w-full ">
        <div className="text-3xl md:text-xl  font-bold mb-4">
          <span className="text-[#e6f060] text-5xl">Discover </span>
          the wonders of farming and sustainable food production.
        </div>
        <p className="text-gray-600">
          Agriculture is the foundation of human civilization, providing food,
          fiber, and fuel, and shaping our relationship with the natural world.
          It's a complex and vital industry, constantly evolving to meet the
          needs of a growing global population while protecting the environment
          and ensuring the well-being of farmers and rural communities.
        </p>
        <Link to="/About">
          {" "}
          <button className="px-6 py-3 bg-[#74d600] rounded-lg mt-10 text-black/50 font-semibold flex items-centers text-xl">
            About us
            <img src="/right-arrows.png" className="w-7  h-7 ml-4" />
          </button>
        </Link>
      </div>
      <div className="sm:hidden block">
        <img src="/hero.png " />
      </div>
    </div>
  );
}

export default Hero;
